import { useMemo } from 'react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets';
import { useQuery } from '@tanstack/react-query';

// Polyfill Buffer for the browser environment
import { Buffer } from 'buffer';
// @ts-ignore
window.Buffer = Buffer;

// Import styles directly
import '@solana/wallet-adapter-react-ui/styles.css';

interface Props {
  children: React.ReactNode;
}

export function SolanaProvider({ children }: Props) {
  // Fetch RPC URL from backend
  const { data: rpcData, isLoading, error } = useQuery({
    queryKey: ['/api/solana/rpc-url'],
    retry: 2,
  });

  const endpoint = useMemo(() => {
    if (rpcData?.rpcUrl) {
      return rpcData.rpcUrl;
    }
    // Fallback to devnet if we can't get the mainnet URL
    return 'https://api.devnet.solana.com';
  }, [rpcData]);

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
    ],
    []
  );

  if (isLoading) {
    return <div>Loading Solana connection...</div>;
  }

  if (error) {
    console.error('Failed to load Solana RPC URL:', error);
    // Continue with devnet as fallback
  }

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          {children}
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export { WalletMultiButton };